import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionInMotion from "./sections/PrecisionInMotion";
import UltimateServices from "./sections/UltimateServices";
import The3StepPatientJourney from "./sections/The3StepPatientJourney";
import TheFirstPartyAdvantage from "./sections/TheFirstPartyAdvantage";
import ReadyToWorkInSaudiArabia from "./sections/ReadyToWorkInSaudiArabia";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PrecisionInMotion />
      <UltimateServices />
      <The3StepPatientJourney />
      <TheFirstPartyAdvantage />
      <ReadyToWorkInSaudiArabia />
      <Footer />
    </div>;
}